// components/protected.jsx

import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getSession, isSessionExpired, clearSession } from "../utils/session";

const ProtectedRoute = ({ children, allowedRoles }) => {
  // null = checking, true = valid, false = invalid
  const [valid, setValid] = useState(null);

  const checkAuth = () => {
    const session = getSession();

    if (!session.isLoggedIn || isSessionExpired()) {
      clearSession();
      setValid(false);
      return;
    }

    if (!allowedRoles.includes(session.role)) {
      setValid(false);
      return;
    }

    setValid(true);
  };

  useEffect(() => {
    // Pehle turant check karo
    checkAuth();

    // Har 60 sec mein check karo (4sec bahut zyada tha — performance waste)
    const interval = setInterval(checkAuth, 60000);
    window.addEventListener("storage", checkAuth);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  // Pehli baar check ho raha hai — kuch mat dikhao (flash avoid)
  if (valid === null) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#0f0f0f",
        color: "#fff",
        fontSize: "16px",
        fontFamily: "Inter, sans-serif",
        gap: "12px"
      }}>
        <div style={{
          width: "20px",
          height: "20px",
          border: "2px solid #ffffff30",
          borderTop: "2px solid #fff",
          borderRadius: "50%",
          animation: "spin 0.7s linear infinite"
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        Loading...
      </div>
    );
  }

  // Invalid / expired → login pe bhejo
  if (!valid) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute;
